module.exports = __webpack_public_path__ + "media/components/print-link/static/icon-print-0b7eabae4700a3acf686eadc8dbf3b0d.svg";